// export const spotifyClientID = process.env.NODE_ENV === "production"
// ? 'b57d1f2d38cd4dae890ec7a389fdddf7'
// : 'be10da71a07142249667189ecceac098';

export const spotifyClientID = 'dc3562d345984d44a0d258afef8c3271';

export const googleAnalyticsTrackingIDs = ['UA-156777129-16'];
